import React, { useEffect, useState } from "react";
import { Button, Col, Collapse, Form, Input, Modal, Row } from "antd";
import Styles from "./Styles";
import { apiPostUsersAuth, apiPostUsersChangepw } from "../../api/api";
import { useLocation } from "react-router-dom";
import { Auth } from "aws-amplify";
import { autoTelHyphenConvert, isEmpty, randomPwGenerator } from "../../utils/comm";

const { Panel } = Collapse;

function FindPassword() {
  const location = useLocation();
  const [passwordCerti, setPasswordCerti] = useState(false);
  const [userForm, setUserForm] = useState({ userNm: "", tel1: "", email: "", reauthCd: "" });
  const [passwords, setPasswords] = useState({ loginPw1: "", loginPw2: "" });
  const [tempPassword, setTempPassword] = useState();
  const [form] = Form.useForm(); // 사용자 저장(추가/수정) form 데이터

  const state = location.state;
  const isNewPasswordChallenge = state && state.isNewPasswordChallenge && true;
  const userData = state ? state.userAttributes : null;

  // 입력폼
  const handleUserFormChange = (event) => {
    const { name, value } = event.target;

    setUserForm({ ...userForm, [name]: value });
  };
  const handleUserTelChange = (event) => {
    const { name, value } = event.target;
    let newTelValue = autoTelHyphenConvert(value);
    setUserForm({ ...userForm, [name]: newTelValue });
    const fields = form.getFieldsValue();
    form.setFieldsValue({
      ...fields,
      [name]: newTelValue,
    });
  };
  const handlePwChange = (event) => {
    const { name, value } = event.target;
    setPasswords({ ...passwords, [name]: value });
  };

  const apiPostUsersChangepwCall = async () => {
    const loginModel = {
      loginId: userForm.email,
      newPassword: passwords.loginPw1,
    };

    try {
      const response = await apiPostUsersChangepw(loginModel);

      if (response.data.code === 0) {
        if (isNewPasswordChallenge) {
          return await changeTemporaryPassword();
        } else {
          return await changePassword();
        }
      } else {
        Modal.info({
          title: "패스워드 변경 실패",
          icon: null,
          content: "message: " + response.data.message,
          okText: "확인",
          centered: true,
          onOk() {},
        });
      }
    } catch (e) {}
  };

  const showAlert = async (type) => {
    switch (type) {
      case "sendAutoNum":
        if (userForm.userNm != null && userForm.userNm !== "" && userForm.email != null && userForm.email !== "") {
          const checkUser = () => {
            return new Promise((res, rej) => {
              apiPostUsersAuth(userForm)
                .then((r) => {
                  if (r != null && r.code === 0) {
                    Auth.forgotPassword(userForm.email).then((res) => {});
                    res(r);
                  } else {
                    rej(Error(r.message));
                  }
                })
                .catch((e) => {
                  rej(e);
                });
            });
          };

          checkUser()
            .then((r) => {
              return Modal.info({
                title: "인증번호 발송",
                icon: null,
                content: (
                  <p>
                    입력 메일주소로 인증번호가 발송 되었습니다.
                    <br />
                    확인 후 입력해주시기 바랍니다.
                  </p>
                ),
                okText: "확인",
                centered: true,
                onOk() {},
              });
            })
            .catch((e) => {
              return authNotFoundUser();
            });
        } else {
          return Modal.info({
            title: "정보 없음",
            icon: null,
            content: <p>사용자 정보를 입력해 주세요</p>,
            okText: "확인",
            centered: true,
            onOk() {},
          });
        }

        break;
      case "next":
        return passwordCerti ? showAlert("changePassword") : changePasswordForgot();
      // return ()
      // (() => {
      //     // changePasswordForgot();
      // });
      case "changePassword":
        const pwValidationResult = checkPassword();

        if (pwValidationResult == null) {
          apiPostUsersChangepwCall().then();
        } else {
          Modal.info({
            title: "패스워드 변경",
            icon: null,
            content: pwValidationResult,
            okText: "확인",
            centered: true,
            onOk() {},
          });
        }

        break;
      default:
        return false;
    }
  };

  function checkPassword() {
    if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$^*.\[\]{}()?"!@#%&/\\,><':;|_~`=+-])[A-Za-z\d$^*.\[\]{}()?"!@#%&/\\,><':;|_~`=+-]{8,}$/.test(
        passwords.loginPw1
      )
    ) {
      return "숫자+대소문자+특수문자 조합으로 8~20자리를 입력하세요.";
    }

    if (passwords.loginPw1 !== passwords.loginPw2) {
      return "패스워드가 일치하지 않습니다.";
    }

    return null;
  }

  const validatePw1 = (validate, value) => {
    if (isEmpty(value)) {
      return Promise.reject(new Error("필수입력입니다."));
    } else if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$^*.\[\]{}()?"!@#%&/\\,><':;|_~`=+-])[A-Za-z\d$^*.\[\]{}()?"!@#%&/\\,><':;|_~`=+-]{8,}$/.test(
        value
      )
    ) {
      return Promise.reject(new Error("숫자+대소문자+특수문자 조합으로 8~20자리를 입력하세요."));
    } else {
      return Promise.resolve();
    }
  };

  const validatePw2 = (validate, value) => {
    if (isEmpty(value)) {
      return Promise.reject(new Error("필수입력입니다."));
    } else if (
      !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$^*.\[\]{}()?"!@#%&/\\,><':;|_~`=+-])[A-Za-z\d$^*.\[\]{}()?"!@#%&/\\,><':;|_~`=+-]{8,}$/.test(
        value
      )
    ) {
      return Promise.reject(new Error("숫자+대소문자+특수문자 조합으로 8~20자리를 입력하세요."));
    } else {
      if (passwords.loginPw1 !== passwords.loginPw2) {
        return Promise.reject(new Error("패스워드가 일치하지 않습니다."));
      } else {
        return Promise.resolve();
      }
    }
  };

  const passwordChangeSuccess = () => {
    return Modal.info({
      title: "패스워드 변경",
      icon: null,
      content: (
        <p>
          패스워드 변경이 완료되었습니다.
          <br />
          재로그인해주시기 바랍니다.
        </p>
      ),
      okText: "확인",
      centered: true,
      onOk: async () => {
        await Auth.signOut();
        window.location.replace("/");
      },
    });
  };

  const passwordChangeFailed = () => {
    return Modal.info({
      title: "패스워드 변경",
      icon: null,
      content: <p>패스워드 변경 중 오류가 발생되었습니다.</p>,
      okText: "확인",
      centered: true,
      onOk: async () => {
        await Auth.signOut();
      },
    });
  };

  const changeTemporaryPassword = async () => {
    const user = await Auth.signIn({
      username: userData.loginId,
      password: userData.loginPw,
    });

    const loggedUser = await Auth.completeNewPassword(user, passwords.loginPw1).catch((reason) => {});

    return passwordChangeSuccess();
  };

  const changePassword = async () => {
    const user = await Auth.signIn({
      username: userForm.email,
      password: tempPassword,
    });

    const response = await Auth.changePassword(user, tempPassword, passwords.loginPw1).catch((reason) => {});

    return passwordChangeSuccess();
  };

  const changePasswordForgot = async () => {
    const tempPw = randomPwGenerator();
    setTempPassword(tempPw);

    Auth.forgotPasswordSubmit(userForm.email, userForm.reauthCd, tempPw)
      .then((value) => {
        setPasswordCerti(true);
      })
      .catch((reason) => {
        setTempPassword(null);
        return authNotFoundUser();
      });
  };

  function authNotFoundUser() {
    Modal.info({
      title: "정보 없음",
      icon: null,
      content: <p>입력하신 정보와 일치하는 계정 정보가 없습니다.</p>,
      okText: "확인",
      centered: true,
      onOk() {},
    });
  }

  useEffect(async () => {
    if (isNewPasswordChallenge) {
      userForm.email = userData.loginId;
      setPasswordCerti(isNewPasswordChallenge);
    }
  });

  return (
    <Styles>
      <div className='login-box'>
        <h1>패스워드 변경</h1>
        <Collapse defaultActiveKey='2'>
          <Panel header='본인인증 후 새 패스워드로 변경' key='2' collapsible='disabled' showArrow={false}>
            {!passwordCerti ? (
              <Form form={form} name='find2' initialValues={{ remember: true }} autoComplete='off'>
                <Form.Item
                  name='userNm'
                  rules={[{ required: true, message: "필수입력입니다." }]}
                  onChange={handleUserFormChange}
                >
                  <Input name='userNm' placeholder='이름' />
                </Form.Item>

                <Form.Item name='tel1' rules={[{ message: "필수입력입니다." }]} onChange={handleUserTelChange}>
                  <Input name='tel1' placeholder='연락처(휴대전화 번호)' />
                </Form.Item>
                <Form.Item
                  name='email'
                  rules={[{ required: true, message: "필수입력입니다." }]}
                  onChange={handleUserFormChange}
                >
                  <Input.Group>
                    <Row gutter={4}>
                      <Col flex='auto'>
                        <Input name='email' placeholder='메일주소' />
                      </Col>
                      <Col flex='none'>
                        <Button
                          onClick={() => {
                            showAlert("sendAutoNum");
                          }}
                          type='primary'
                        >
                          인증번호
                        </Button>
                      </Col>
                    </Row>
                  </Input.Group>
                </Form.Item>
                <Form.Item
                  name='reauthCd'
                  rules={[{ required: true, message: "필수입력입니다." }]}
                  onChange={handleUserFormChange}
                >
                  <Input id='reauthCd' name='reauthCd' placeholder='인증번호 6자리 숫자 입력' />
                </Form.Item>
              </Form>
            ) : (
              <Form name='setPassword' initialValues={{ remember: true }} autoComplete='off'>
                <Form.Item
                  name='loginPw1'
                  rules={[{ required: true, validator: validatePw1 }]}
                  value={passwords.loginPw1}
                  onChange={handlePwChange}
                >
                  <Input.Password name='loginPw1' placeholder='새 패스워드(영문+숫자+특수문자 조합 8~20자)' />
                </Form.Item>
                <Form.Item
                  name='loginPw2'
                  rules={[{ required: true, validator: validatePw2 }]}
                  value={passwords.loginPw2}
                  onChange={handlePwChange}
                >
                  <Input.Password name='loginPw2' placeholder='새 패스워드 재입력' />
                </Form.Item>
              </Form>
            )}
          </Panel>
        </Collapse>
        <Button
          type='primary'
          htmlType='submit'
          className='btn-large'
          onClick={() => {
            showAlert("next");
          }}
        >
          다음
        </Button>
      </div>
    </Styles>
  );
}

export default FindPassword;
